<template>
	<div>
		{{ tradable.product.origin }}
		{{
			$cropOptions.getLocalizedLabel(
				tradable.product.grade,
				$cropOptions.productGradeOptions
			)
		}}, {{ __("Harvest") }} {{ tradable.product.harvest }}
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
	},
};
</script>
